import { isEnrichmentOutsideCut, TEnrichmentTimeRange } from './is-enrichment-outside-cut';

function hasEnrichmentsOutsideCut(
  enrichments: TEnrichmentTimeRange[],
  cutStart: Date | null,
  cutEnd: Date | null
): boolean {
  return enrichments.some(enrichment => isEnrichmentOutsideCut(enrichment, cutStart, cutEnd));
}

export { hasEnrichmentsOutsideCut };
